var render, staticRenderFns
import script from "./ChartjsComponentBarTeacherChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsComponentBarTeacherChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Documents/GitHub/cis-planning/survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports